module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox, $) {
	'use strict';

	fox.registerWidget('PostViewer', {
		configure: function () {
			this.registerOptions('', {
				'embed.container': '#post-container',
				manualRender: true,
				autoRender: true,
				externalLoad: true,
				contentIdPrefix: 'content-container-',
				textNodeTemplate: false,
				quoteNodeTemplate: false,
				photoNodeTemplate: false,
				videoNodeTemplate: false,
				videoContainer: 'flash-player-',
				widgets: {
					loader: {
						widget: 'PromisePreloader',
					},
					dl: {
						widget: 'Datalayer',
						method: 'blog.getPost',
						limit: 1,
						cacheChannel: 'content'
					},
					currentRating: {
						widget: 'Social_Rating',
						targetDl: '@parent #dl',
						'embed.widget': '@parent #list',
						template: 'social_rating_blog',
						subject: 'blog'
					},
					fullscreenView: {
						widget: 'FullscreenView',
						template: 'sitepage_gallery_fullscreenview_cutted_for_blogpost'
					},
					postComments: {
						widget: 'Social_Comments',
						showComments: true,
						targetDl: '@parent #dl',
						template: 'social_comment_scene',
						'embed.widget': '@parent #list',
						dlLimit: 5,
						'handleDom.toggleForm': {
							targetWidget: '@parent #list'
						},
						formOptions: {
							'hooks.onStopRendering': function () {
								if (this.getParent().getParent().getPd().allowComment === 0) {
									this.dom1('form').style.display = 'none';
								}
							}
						},
						subject: 'blog'
					}
				},
				'list.hooks.onStopRendering': '@parent:_listRender',
				handleDom: {
					openFullscreen: {
						target: '.pl-text img, .content-img img',
						event: 'click',
						targetWidget: '@this #list .Widget',
						callback: 'openFullscreen'
					},
				}
			});

			this.callParent('configure', arguments);
		},

		init: function () {
			this.registerOptions('#postComments .Grid', {
				pager: this.getOption('commentsPager')
			});

			this.registerOptions('#loader', {
				'embed.container': this.getOption('list.container') || this.getOption('list.embed.container')
			});

			this._pid = null;
			this._postData = null;
			this._postResources = [];
		
			this.callParent('init', arguments);
		},

		running: function () {
			this._list = this.rwom1('#list');
			this.saveOldMeta();
		
			this.callParent('running', arguments);
		},

		activate: function () {	
			this.callParent('activate', arguments);

			this.saveOldMeta();
			this.dispatchEvent('postActivated');
		},

		deactivate: function () {
			this.callParent('activate', arguments);

			this.restoreOldMeta();
		},

		setPd: function () {
			var pd;

			pd = this.dl.getCollection();

			if (pd.length) {
				this._postData = pd[0];
				this._postResources = this._postData.resources;
			}
			
			return this;
		},

		getPd: function () {
			return this._postData;
		},

		fetch: function (id) {
			this._postData = null;
			this._pid = id;

			return this._loadPost().then(this.setMetaData.bind(this));
		},

		getPid: function () {
			return this._pid;
		},

		_loadPost: function () {
			var loader = this.rwom1('#loader');

			return loader.show(this.dl.setTransitParameter('id', this._pid).load());
		},

		_listRender: function () {
			this.setPd();

			this.fillPostContent();
		},

		fillPostContent: function () {
			if (!this.getPd()) {
				fox.site.gotoPage('join');
				return;
			}
			fox.each(this.getPd().contents, function (val, key) {
				if (val.type === 4) {
					this._embedVideo(val);
				} else {
					this._embedSimpleW(val);	
				}
				
			}, this);
		},

		_embedSimpleW: function (contentData) {
			var wOpt;

			wOpt = {
				autoRender: true,
				'embed.container': '#' + this.getOption('contentIdPrefix') + contentData.id,
				'templateOptions.content': contentData.content
			};

			switch (contentData.type) {
				case 1: 
					wOpt = fox.merge(wOpt, {
						template: this.getOption('textNodeTemplate') || 'div.pl-text{$[content]}'
					});
					break;
				case 2:
					wOpt = fox.merge(wOpt, {
						template: this.getOption('quoteNodeTemplate') || 'div.pl-text.quote{$[content]}'
					});
					break;
				case 3:
					wOpt['templateOptions.postId'] = contentData.postId;
					
					if (contentData.description) {
						wOpt['templateOptions.description'] = contentData.description;
					}

					wOpt = fox.merge(wOpt, {
						template: this.getOption('photoNodeTemplate') || 'div.content-img>img[src="$[content]"]'
					});
					break;
			}

			return this
					._list
					.embedWidget('cw_' + fox.uniqid(), 'Widget', wOpt)
					.run();
		}, 

		_embedVideo: function (contentData) {
			var wOpt;

			wOpt = {
				container: '#' + this.getOption('contentIdPrefix') + contentData.id,
				template: this.getOption('videoNodeTemplate'),
				'templateOptions.videoContainer': [this.getOption('videoContainer'), contentData.id].join(''),
				autoRender: true,
				'widgets.player': {
					widget: 'FlashPlayer2',
					container: ['#', this.getOption('videoContainer'), contentData.id].join(''),
					standAloneMode: true,
					videoUrl: JSON.parse(decodeURIComponent(contentData.content)).path,
					'playerConfig.plugins.controls': {
						rates: false,
						'autoHide.enabled': true,
					},
					'playerConfig.clip.autoPlay': false
				},
				'handleWom.addedToDom': {
					event: 'addedToDom',
					widget: '@this',
					callback: '#player:runPlayer'
				}
			};

			if (contentData.description) {
				wOpt['templateOptions.description'] = contentData.description;
			}

			return this
					._list
					.embedWidget('cw_' + fox.uniqid(), 'Widget', wOpt)
					.run();
		},

		openFullscreen: function (e) {	
			var src = $(e).attr('src'),
				alt = $(e).attr('alt'),
				photoData = {},
				rid = null;

			rid = this.getUrlParam(src, 'rid');

			photoData = {
				id: 1,
				altTag: alt,
				url: !fox.isEmpty(this._postResources[rid]) ? this._postResources[rid].path : src
			};

			if (photoData) {
				this.rwom1('#fullscreenView').setPhotoCollection([photoData]).setCurrentPhoto(photoData).show();
			}
		},

		getUrlParam: function (src, paramName) {
			var reParam = new RegExp( '(?:[\?&]|&)' + paramName + '=([^&]+)', 'i' ),
				match = src.match(reParam);

			return ( match && match.length > 1 ) ? match[ 1 ] : null ;
		},

		saveOldMeta: function () {
			this.metaTitle = fox.dom.selectFirst('title', document).innerHTML;
			var descrTag = fox.dom.selectFirst('meta[name="description"]', document);
			if (descrTag) {
				this.metaDescription = fox.dom.wrap(descrTag).attr('content');
			}
		},

		restoreOldMeta: function () {
			fox.dom.selectFirst('title', document).innerHTML = this.metaTitle;
			var descrTag = fox.dom.selectFirst('meta[name="description"]', document);
			if (descrTag) {
				fox.dom.wrap(descrTag).attr('content', this.metaDescription);
			}
		},

		setMetaData: function () {
			var data = this.rwom1('#dl').getCollection()[0];
			var metaTitle = fox.objectGet(data, 'metaTitle');
			var description = fox.objectGet(data, 'metaDescription');
			var title = fox.objectGet(data, 'title');
			/*var titleTag = fox.dom.selectFirst('title', document);
			var descrTag = fox.dom.selectFirst('meta[name="description"]', document);

			if (!descrTag) {
				descrTag = document.createElement('meta');
				descrTag.setAttribute('name', 'description');
				this.window.document.head.appendChild(descrTag);
			}

			titleTag.innerHTML = metaTitle ? metaTitle : title;

			descrTag.setAttribute('content', description || ''); */
			var metaDescription = fox.dom.selectFirst('meta[name="description"]');
			metaTitle = metaTitle !== '' ? metaTitle : title;
			document.title = metaTitle + " - " + fox.getEnv('screenName')  + "'s blog";
			var defaultDescription  = "Check out my latest blog post! " + metaTitle + " - " + fox.getEnv('screenName') + "'s blog."
			description !== '' ? metaDescription.setAttribute('content', description) : metaDescription.setAttribute("content", defaultDescription);

			if($(this.element).length){
				$('body, html').animate({
					scrollTop: $(this.element).offset().top - 50
				}, 500);
			}
			
		},

		getContentId: function () {
			return this._pid;
		}

	}, 'Grid');

})(fox, fox.jQuery);

 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/blog/postViewer.js
// module id = 852
// module chunks = 4